import breaDcrumb from "@/components/breadcrumb";
import { mapGetters } from "vuex";
import { formatTreeData, /**formatTreeDataByKeys */ transDataByKey, getLimitTreeFeilds, transData } from "@/utils/utils";
import { queryOrgPageByLimit } from "@/api/basedata/organization.js";
import { queryJobPageByLimit } from "@/api/basedata/jobs.js";
import { queryRolePageByLimit } from "@/api/basedata/role.js";
import { queryUsersByLimit } from "@/api/basedata/user";
import { queryBusinessList } from "@/api/basedata/business.js";
import {
  saveOrUpdate,
  queryIds,
  functionTree,
  get_system_function_buttonByuser,
  // get_table_title,
  query_table_dataV2,
  save_or_update,
  get_data_limits_settings,
  queryIds1,
  get_data_limits_second_settings,
  get_data_limits_table_settings,
  getDataLimitsTableForUser,
} from "@/api/basedata/permissions.js";
import { getDetail, queryLimitByAuth } from "@/api/basedata/DataAccess.js";
import styles from "@/app.scss";
import { Loading } from "element-ui";
import { getUserInfo } from "@/utils/auth.js";
import { get_user_auth_source, get_user_data_source, get_user_data_source_tables, queryUserPageByLimit } from "@/api/basedata/user";

let jobslist = [];
let userlist = [];
let rolelist = [];
export default {
  components: {
    breaDcrumb,
  },
  data() {
    return {
      bg_color: styles.bg_color,
      currrenIndex: 1,
      leftList: [
        // {
        //   text: "组织",
        //   value: "organization",
        // },
        {
          text: "岗位",
          value: "station",
        },
        {
          text: "用户",
          value: "user",
        },
        {
          text: "角色",
          value: "role",
        },
      ],
      leftIndex: "user",
      rightList: [
        {
          text: "功能权限",
          value: 1,
        },
        {
          text: "数据权限",
          value: 5,
        },
        {
          text: "App权限",
          value: 2,
        },
        {
          text: "微信小程序权限",
          value: 3,
        },
      ],
      rightIndex: 1,
      treearr: [],
      treearrIds: [],
      treearrId: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      sherchDdefaultProps: {
        children: "buttonList",
        label: "buttonName",
      },
      sherchNode: [],
      /* readOnlyDefaultProps: {
        children: "children",
        label: "name",
        disabled: "name",
      }, */
      josarr: [],
      jobsinput: "",
      jobIds: [],
      jobsId: "",
      jobsIndex: null,
      rolearr: [],
      roleinput: "",
      roleIds: [],
      roleId: "",
      roleIndex: null,
      userarr: [],
      userinput: "",
      userIds: [],
      userId: "",
      userIndex: null,
      functiontreeData: [],
      loading: false,
      /*数据权限详细列表*/
      newtree: [],
      tableData: [],
      allTableData: [],
      table: "",
      tableTitle: [],
      functionId: "",
      shujucheckarr: [],
      shujucheckarrarr: [],
      rightloading: false,
      leftloading: false,
      timer: "",
      radio: "",
      radio1: "",
      show: "",
      tree1: "",
      tableShow: [],
      foreignId: "",
      choiseId: "",
      searchValue: "",
      limitInfo: {
        showType: "show_list",
      },
      treeInfo: {
        id: "",
        keyId: "",
        pid: "",
        keys: [],
      },
      authTreeData: [],
      defaultAuthData: [],
      allNode: [], //功能权限的所有树节点
      /*  checkedArr: [],//被选中的节点 */
      allDataNode: [], //数据权限树的节点
      checkedDataArr: [], //数据权限被选中的节点
      Sherchshow: {}, //数据权限左边的id以及权限来源
      showAuthoritSource: {
        user: "用户",
        organization: "组织",
        role: "角色",
        station: "岗位",
      },
      sherchShowtable: [], //
      dataLoading: false,
      fiveLoading: false,
    };
  },
  watch: {
    userinput() {
      this.userarr = new Array();
      if (this.userinput == "") {
        this.userarr = [];
      } else {
        userlist.forEach(item => {
          if (item.name.indexOf(this.userinput) !== -1) {
            this.userarr.push(item);
          }
        });
      }
    },
    jobsinput() {
      this.josarr = new Array();
      if (this.jobsinput == "") {
        this.josarr = jobslist;
      } else {
        jobslist.forEach(item => {
          if (item.name.indexOf(this.jobsinput) !== -1) {
            this.josarr.push(item);
          }
        });
      }
    },
    roleinput() {
      this.rolearr = new Array();
      if (this.roleinput == "") {
        this.rolearr = rolelist;
      } else {
        rolelist.forEach(item => {
          if (item.name.indexOf(this.roleinput) !== -1) {
            this.rolearr.push(item);
          }
        });
      }
    },
    searchValue: {
      deep: true,
      handler() {
        this.debounce(this.changeValue, 2000);
      },
    },
  },
  async created() {
    const params = {
      page: 1,
      pageSize: 99999,
      fields: "ORG_AUTH",
    };
    this.leftloading = true;
    /*获取用户*/
    await queryUsersByLimit({
      ...params,
      userEentrance: "entrance_manager",
      enable: 1,
    }).then(res => {
      userlist = JSON.parse(JSON.stringify(res.data.data));
      // this.userarr = JSON.parse(JSON.stringify(res.data.data));
    });
    this.leftloading = false;
  },
  async mounted() {
    this.rightloading = true;
    //   this.leftloading = true;
    const params = {
      page: 1,
      pageSize: 99999,
      fields: "ORG_AUTH",
    };
    //   /*获取用户*/
    //  await queryUsersByLimit({
    //     ...params,
    //     userEentrance: "entrance_manager",
    //     enable: 1,
    //   }).then(res => {
    //     userlist = JSON.parse(JSON.stringify(res.data.data));
    //     this.userarr = JSON.parse(JSON.stringify(res.data.data));
    //   });
    //   this.leftloading = false;
    /*获取功能树*/
    this.changetight(1);
    /*获取数据权限系统树*/
    await queryBusinessList(params).then(res => {
      res.data.forEach(item => {
        item.children = [];
        item.hierarchytyp = "system";
      });
      this.newtree = res.data;
      this.newtree.splice(0, 0, {
        hierarchytyp: true,
        name: "全部",
        id: 0,
        children: [],
      });
      let arr = [];
      params.foreignGrant = 1;
      queryLimitByAuth().then(res => {
        arr = res.data.map(item => {
          item.icon = "iconfont icontree_icon_text";
          return item;
        });
        this.newtree.forEach(b => {
          b.request = 1;
          for (let c in arr) {
            if (b.id == arr[c].systemId) {
              b.children.push(arr[c]);
            }
          }
          if (b.systemId == "") {
            this.newtree[0].children.push(b);
          }
        });
      });
    });
    console.log(this.newtree);
    /*获取组织*/
    await queryOrgPageByLimit({
      ...params,
      showEnable: 0,
    }).then(res => {
      if (res.code === 1001) {
        const { data } = res.data;
        this.treearr = transData(data, "id", "parentId", "children", "parent_id");
        console.log(this.treearr);
      }
    });
    /*获取角色*/
    await queryRolePageByLimit({
      ...params,
      permissionParameter: "JCPT_YWSYS",
      roleEentrance: "entrance_manager",
      // roleEentrance: 'entrance_personal',
      enable: 1,
    }).then(res => {
      rolelist = JSON.parse(JSON.stringify(res.data.data));
      this.rolearr = JSON.parse(JSON.stringify(res.data.data));
    });
    /*获取岗位*/
    await queryJobPageByLimit({
      ...params,
      enable: 1,
    }).then(res => {
      jobslist = JSON.parse(JSON.stringify(res.data.data));
      this.josarr = JSON.parse(JSON.stringify(res.data.data));
    });
  },

  methods: {
    //动态加载树组件根组织的成员
    loadNode(node, resolve) {
      //添加根节点
      if (node.level === 0) {
        const data = [...this.treearr];
        return resolve(data);
      }
      //node是当前点击的节点
      if (node.data) {
        //判断是否有子节点，没有就发送请求去获取节点
        if (node.data.children == undefined) {
          //如果节点为人的话，就不发送请求去获取子节点了
          if (node.data.loginAccount) {
            return resolve([]);
          }
          const params = {
            page: 1,
            pageSize: 100,
            organizationId: node.data.id,
            userEentrance: "entrance_manager",
          };
          queryUserPageByLimit(params).then(res => {
            node.data.children = res.data.data;
            resolve([...res.data.data]);
            //设置发送请求获取的子节点为叶子节点
            node.childNodes.forEach(item => {
              item.isLeaf = true;
            });
          });
        } else {
          //有就直接添加子节点
          resolve([...node.data.children]);
        }
      } else {
        resolve([]);
      }
    },

    //权限查看时切换右侧功能和数据权限展示时，另外获取当前选中人的权限
    sherchChangetigth(value) {
      this.changetight(value);
      this.sherchHandleClick({ id: this.choiseId });
    },
    //根据树的叶子成员的UserId获取权限列表
    sherchHandleClick(e) {
      console.log(e);
      //切换人的时候把数据权限的树装图的数据置空
      this.checkedDataArr = [];
      //暂时调试试用之前的接口
      /*  this.userIndex = e.createUserId;
       this.userId = e.createUserId;
       this.choiseId = e.createUserId; */
      this.userIndex = e.id;
      this.userId = e.id;
      this.choiseId = e.id;
      if (this.rightIndex == "5") {
        this.sherchShuju(e.id);
      } else {
        setTimeout(() => {
          if (e.children) {
            return;
          } else {
            this.sherchButton(e.id); //权限查看的功能查看
          }
        }, 1000);
      }
    },

    handleClick(e) {
      //切换人的时候把数据权限的树装图的数据置空
      this.checkedDataArr = [];
      //暂时调试试用之前的接口
      /*  this.userIndex = e.createUserId;
       this.userId = e.createUserId;
       this.choiseId = e.createUserId; */
      this.userIndex = e.id;
      this.userId = e.id;
      this.choiseId = e.id;
      if (this.rightIndex == "5") {
        this.getshuju(e.id);
      } else {
        this.getcheckbutton(e.id); //
      }
      //根据所有节点选出被选的节点展示
      /*     setTimeout(() => {
        //获取被选中的节点
        let checkedNode = this.$refs.functiontree.getCheckedNodes()
        //所有节点
         console.log(checkedNode);
        if (checkedNode !== []) {
          //在所有节点中获取所有选中节点的父亲节点
          let fun = (nodes) => {
            let fathers = []
            const cloneData = JSON.parse(JSON.stringify(this.allNode))
            if (cloneData.length) {
              let father = {}
              nodes.forEach(item => {
                father = cloneData.filter(father => {
                  return father.id === item.parentId
                })
                fathers.push(...father)
              })
              //数组去重
              fathers = [...new Set(fathers)]
              return fathers
            }
          }
          let fathers = fun(checkedNode)
          //获取从所有节点z中拿到的父亲节点
          let f = fathers
          //获取选中的非叶子节点
          let leaf = checkedNode.filter(item => {
            return item.systemId
          })
          leaf.forEach(item => {
            //每次fathers就会少一个
            fathers = f
            f = fathers.filter(getfather => {
              return getfather.id !== item.id
            })
          })
          console.log(f);
          let diGuiGetAllpar = (getnode) => {
            if (getnode.length) {
              let grandpar = fun(getnode)
              getnode.push(...grandpar)
              console.log(getnode);
              if (grandpar.some(item => { item.parentId !== "parent_id" })) {
                console.log("aaa");
                diGuiGetAllpar(grandpar)
              } else {
                return getnode
              }
              return getnode
            }
          }
          //递归获取所有父组件的父组件
          let grandpar = diGuiGetAllpar(f)

          if (grandpar == undefined) {
            grandpar = []
          }
          //  其中包括重复的，grandpar没有children
          checkedNode = [...grandpar, ...checkedNode]
          //去重
          let obj = {}
          checkedNode = checkedNode.reduce((prv, cur) => {
            if (obj[cur.name]) {
              return prv
            } else {
              obj[cur.name] = true
              prv.push(cur)
              return prv
            }
          }, [])
          console.log(checkedNode);
          this.checkedArr = formatTreeData(checkedNode, "id", "parentId", "children", "parent_id")
        } else {
          this.checkedArr = []
        }
        console.log(this.checkedArr);
      }, 1000); */
      //使用新接口
      /* get_user_auth_source({userId:e.createUserId}).then((res)=>{
          console.log(res);
      }) */
    },
    sherchShuju(userId) {
      get_user_data_source({
        userId,
      }).then(res => {
        this.Sherchshow = res.data;
      });
    },
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    changeValue() {
      if (this.searchValue === "") {
        this.tableData = this.allTableData;
      } else {
        this.tableData = this.allTableData.filter(item => this.tableTitle.some(items => item[items.columnName]?.indexOf(this.searchValue) > -1));
      }
      /**
       * @Description: 设置选中
       * @param {*} rows
       * @Author: wangwangwang
       */
      let data1 = {
        dataLimitsJoinId: this.table.id,
        foreignId: this.getforeignId(),
        foreignType: this.leftIndex,
      };
      /*获取表回显*/
      get_data_limits_table_settings(data1).then(res => {
        this.tableShow = res.data;
        let rows = this.tableShow.map(res => {
          let index = this.tableData.findIndex(item => item.ID == res.dataId);
          return this.tableData[index];
        });
        rows = rows.filter(d => d);
        this.toggleSelection(rows);
      });
    },
    /*
     *数据权限
     */
    /**数据权限里系统回显*/
    getshuju(id) {
      this.radio = "";
      this.tableData = [];
      this.tree1 = new Date().getTime();
      get_data_limits_settings({
        foreignId: id,
        foreignType: this.leftIndex,
      }).then(res => {
        this.show = res.data;
      });
    },

    /*获取数据权限表get_detail*/
    async gettable(data) {
      let _this = this;
      _this.tableShow = [];
      this.defaultAuthData = [];
      if (!_this.getforeignId()) {
        _this.$message({
          message: "警告哦，请在左侧选择要关联的数据",
          type: "warning",
        });
        return;
      }
      /*获取表头数据有表格或者树形图两个情况*/
      _this.table = data;
      await getDetail({
        id: data.id,
      }).then(res => {
        _this.limitInfo = res.data;
        _this.tableTitle = res.data.items;
      });
      this.rightloading = true;

      let params = {
        page: 1,
        pageSize: 99999,
        dataLimitsId: _this.table.id,
        // systemId: _this.table.systemId,
        dataSourceId: _this.table.dataSourceId,
        tableName: _this.table.tableName,
        foreignType: _this.leftIndex,
        foreignId: _this.getforeignId(),
      };
      /*获取表、数据query_db_page*/
      await query_table_dataV2(params).then(async res => {
        if (!res.data || !res.data.data) {
          _this.tableData = [];
          _this.authTreeData = [];
          _this.allTableData = [];
          this.rightloading = false;
          this.$message.warning("未获取到数据，可能是数据源配置问题导致");
          return;
        }
        _this.tableData = res.data.data;
        _this.allTableData = res.data.data;

        //获取限制列表
        let rows = getLimitTreeFeilds(_this.limitInfo.items);
        console.log(rows);
        this.treeInfo = rows;
        if (_this.limitInfo.showType === "show_tree") {
          // this.authTreeData = formatTreeDataByKeys(res.data.data, rows["id"], rows["pid"], rows["keys"], "children", "parent_id");
          // 格式化table数据
          this.allDataNode = res.data.data;

          //树组件数据
          this.authTreeData = transDataByKey(res.data.data, rows["id"], rows["pid"], rows["keys"], "children");
        }
        console.log(this.limitInfo.showType, res.data.data, this.authTreeData);

        //非admin号只显示当前账号所拥有权限--开始
        if (getUserInfo().adminStatus == 3) {
          let data1 = {
            dataLimitsJoinId: data.id,
            foreignId: getUserInfo().userId,
            foreignType: this.leftIndex,
          };
          /*获取表回显*/
          let tableShowArr = [];
          await getDataLimitsTableForUser(data1).then(res => {
            tableShowArr = res.data;
          });
          const deWeight = (item, cur) => {
            if (tableShowArr.some(item1 => item1.dataId == cur.ID)) {
              item.push(cur);
            }
            return item;
          };
          this.allTableData = this.allTableData.reduce(deWeight, []);
          this.tableData = this.allTableData;
        }
        //非admin号只显示当前账号所拥有权限--结束
      });
      let data1 = {
        dataLimitsJoinId: data.id,
        foreignId: _this.getforeignId(),
        foreignType: _this.leftIndex,
      };

      /*获取表回显，获取被勾选的数据get_data_limits_table*/
      await get_data_limits_table_settings(data1).then(res => {
        _this.tableShow = res.data;
        let list = [];
        if (_this.limitInfo.showType === "show_tree") {
          res.data.map(item => {
            list.push(item.dataId);
            // this.$refs.rightAuthTree.setChecked(item.dataId, true, false);
          });
          this.defaultAuthData = list;
          console.log("回显：", list);
        }
        this.$nextTick(() => {
          this.rightloading = false;
        });
      });
      let rows = _this.tableShow.map(res => {
        let index = _this.tableData.findIndex(item => item.ID == res.dataId);
        return _this.tableData[index];
      });
      rows = rows.filter(d => d);

      if (_this.limitInfo.showType === "show_list") {
        await _this.toggleSelection(rows);
      }
      // this.tableData.forEach(res => {
      //   if (this.tableShow.findIndex(item => (item.dataId == res.ID)) !== -1) {
      //     res.checkStatus = 1
      //   }
      // })

      /*       //生成只显示被勾选的节点
      if (this.allDataNode !== []) {
        setTimeout(() => {
          //数据权限全部被勾选的节点
          let checkedNodeData = this.$refs.rightAuthTree.getCheckedNodes()
          if (checkedNodeData !== []) {
            //从全部节点中选出和被勾选节点相同ID的节点
            let checked = this.allDataNode.filter(all => checkedNodeData.find(checked => all.ID === checked.ID))
            //散节点格式化
            let node = transDataByKey(checked, this.treeInfo["id"], this.treeInfo["pid"], this.treeInfo["keys"], "children")
            node = [...new Set(node)]
            //递归去重所有数组中的对象、以及对象中的children数组中的对象
            let diGuiQuChong = (nodeArr) => {
              if (nodeArr.length) {
                //对一级节点遍历
                let qc = nodeArr.map(re => {
                  //当前若是有下级目录
                  if (re.children) {
                    //对下级目录的数组去重
                    let qcchild = [...new Set(re.children)]
                    //对下级目录的数组进行递归操作
                    return { ...re, children: [...new Set(diGuiQuChong(qcchild))] }
                  } else {
                    return re
                  }
                })
                return [...new Set(qc)]
              } else {
                return nodeArr
              }
            }
            this.checkedDataArr = diGuiQuChong(node)
            console.log(this.checkedDataArr);
          }
        }, 500);
      } */
    },
    async gettable2(data) {
      console.log(data);
      this.dataLoading = true;
      let datatType = await getDetail({ id: data.id });
      //获取限制信息showType表示是list还是tree
      this.limitInfo = datatType.data;
      //获取表头
      this.tableTitle = datatType.data.items;

      let params = {
        page: 1,
        pageSize: 99999,
        dataLimitsId: data.id,
        dataSourceId: data.dataSourceId,
        tableName: data.tableName,
        foreignType: this.leftIndex,
        foreignId: this.getforeignId(),
      };
      /*获取所有表的数据或树组件组成的数据，后面和get_user_data_source_tables接口对比过滤掉其他数据，query_db_page接口*/
      await query_table_dataV2(params).then(res => {
        if (!res.data || !res.data.data) {
          this.tableData = [];
          this.authTreeData = [];
          this.allTableData = [];
          this.rightloading = false;
          this.$message.warning("未获取到数据，可能是数据源配置问题导致");
          return;
        }
        this.tableData = res.data.data;
        this.allTableData = res.data.data;
      });
      //要展示的表格数据或树组件的数据
      let res = await get_user_data_source_tables({ userId: this.userId, dataLimitsJoinId: data.id });
      console.log("表格列表,或树列表", res.data);
      console.log("总数据", this.allTableData);
      if (this.limitInfo.showType == "show_list") {
        //过滤掉query_db_page中没get_user_data_source_tables中的数据
        this.sherchShowtable = this.allTableData.filter(item => {
          return res.data.find(ite => {
            return item.ID == ite.dataId;
          });
        });
        //增加source权限来源字段，
        this.sherchShowtable = this.sherchShowtable.map(item => {
          let source = res.data
            .filter(ite => {
              return ite.dataId == item.ID;
            })[0]
            .source.split(",");
          source = source
            .map(ite => {
              return this.showAuthoritSource[ite];
            })
            .join(",");
          return { ...item, source };
        });
      } else if (this.limitInfo.showType == "show_tree") {
        console.log("showType==show_tree");
        let rows = getLimitTreeFeilds(this.limitInfo.items);
        console.log("rows", rows);

        //过滤掉query_db_page中没get_user_data_source_tables中的数据
        let treeData = this.allTableData.filter(item => {
          return res.data.find(ite => {
            return item.ID == ite.dataId;
          });
        });
        treeData = treeData.map(item => {
          let source = res.data
            .filter(ite => {
              return ite.dataId == item.ID;
            })[0]
            .source.split(",");
          return { ...item, source };
        });
        console.log("treeData", treeData);
        // this.authTreeData = formatTreeDataByKeys(res.data.data, rows["id"], rows["pid"], rows["keys"], "children", "parent_id");
        this.checkedDataArr = transDataByKey(treeData, rows["id"], rows["pid"], rows["keys"], "children");
        console.log("格式化树组件", this.checkedDataArr);
      }
      this.dataLoading = false;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    },
    /*选择后绑定数据权限表*/
    multipleTableFun(val) {
      let allHasData = this.tableShow.filter(item => val.some(items => item.dataId == items[this.treeInfo["keyId"]]));
      let deleteData = this.tableShow.filter(item => !allHasData.some(items => item.dataId == items.dataId));
      console.log(JSON.parse(JSON.stringify(deleteData)));
      let addData = val.filter(item => !allHasData.some(items => item[this.treeInfo["keyId"]] == items.dataId));
      deleteData = deleteData.map(res => ({
        tableName: this.table.tableName,
        status: 0,
        id: res.id,
        dataId: res.dataId,
      }));
      addData = addData.map(res => ({
        tableName: this.table.tableName,
        status: 1,
        dataId: res[this.treeInfo["keyId"]],
      }));
      let dataLimitsDataList = [...deleteData, ...addData];
      console.log(dataLimitsDataList);
      let arr = [
        {
          foreignType: this.leftIndex,
          foreignId: this.getforeignId(),
          systemId: this.table.systemId,
          tableName: this.table.tableName,
          dataLimitsId: this.table.id,
          dataLimitsDataList: dataLimitsDataList,
        },
      ];
      let loadingInstance = Loading.service({ text: "数据授权中..." });
      save_or_update(arr).then(async () => {
        loadingInstance.close();
        this.$message.success("操作成功");
      });
    },
    /*
     *数据权限快捷配置
     *数据表数据
     */
    /**获取数据表*/
    async gettable1(data) {
      /*获取表数据*/
      this.table = data;
      await getDetail({
        id: data.id,
      }).then(res => {
        this.limitInfo = res.data;
        this.tableTitle = res.data.items;
      });
      let params = {
        page: 1,
        pageSize: 99999,
        dataSourceId: data.dataSourceId,
        dataLimitsId: data.id,
        tableName: data.tableName,
        foreignType: this.leftIndex,
        foreignId: this.getforeignId(),
      };
      await query_table_dataV2(params).then(async res => {
        this.tableData = res.data.data;
        this.allTableData = res.data.data;

        console.log(this.limitInfo.showType);
        let rows = getLimitTreeFeilds(this.limitInfo.items);
        console.log(rows);
        this.treeInfo = rows;
        if (this.limitInfo.showType === "show_tree") {
          let rows = getLimitTreeFeilds(this.limitInfo.items);

          // this.authTreeData = formatTreeDataByKeys(res.data.data, rows["id"], rows["pid"], rows["keys"], "children", "parent_id");
          this.authTreeData = transDataByKey(res.data.data, rows["id"], rows["pid"], rows["keys"], "children");
        }
        //非admin号只显示当前账号所拥有权限--开始
        if (getUserInfo().adminStatus == 3) {
          let data1 = {
            dataLimitsJoinId: data.id,
            foreignId: getUserInfo().userId,
            foreignType: this.leftIndex,
          };
          /*获取表回显*/
          let tableShowArr = [];
          await getDataLimitsTableForUser(data1).then(res => {
            tableShowArr = res.data;
          });
          const deWeight = (item, cur) => {
            if (tableShowArr.some(item1 => item1.dataId == cur.ID)) {
              item.push(cur);
            }
            return item;
          };
          this.allTableData = this.allTableData.reduce(deWeight, []);
          this.tableData = this.allTableData;
        }
        //非admin号只显示当前账号所拥有权限--结束

        this.show = [];
        this.radio1 = "";
        if (this.leftIndex == "organization") {
          this.$refs.tree.setCheckedKeys([]);
        }
        if (this.leftIndex == "station") {
          this.jobIds = [];
        }
        if (this.leftIndex == "user") {
          this.userIds = [];
        }
        if (this.leftIndex == "role") {
          this.roleIds = [];
        }
      });
    },
    /**获取数据回显*/
    async getshuju1(ID) {
      let data = {
        foreignType: this.leftIndex,
        systemId: this.table.systemId,
        tableName: this.table.tableName,
        dataId: ID,
        dataLimitsId: this.table.id,
      };
      await get_data_limits_second_settings(data).then(res => {
        this.show = res.data;

        let arr = res.data.map(res => res.dataId);
        if (this.leftIndex == "organization") {
          this.$refs.tree.setCheckedKeys(arr);
        }
        if (this.leftIndex == "station") {
          this.jobIds = arr;
        }
        if (this.leftIndex == "user") {
          this.userIds = arr;
        }
        if (this.leftIndex == "role") {
          this.roleIds = arr;
        }
      });
    },
    /**绑定数据权限*/
    handleSelectionChange1(key) {
      let _this = this;
      if (!_this.table) {
        this.$message({
          message: "警告哦，请在左侧选择要关联的数据权限",
          type: "warning",
        });
        return;
      }
      let loadingInstance = Loading.service({ text: "数据授权中..." });
      let allkey = _this.show.filter(item => key.some(items => item.dataId == items));
      let addData = key.filter(item => !allkey.some(items => item == items.dataId));
      let delData = _this.show.filter(item => !allkey.some(items => item.dataId == items.dataId));
      addData = addData.map(res => {
        let obj = {
          foreignType: _this.leftIndex,
          foreignId: res,
          systemId: _this.table.systemId,
          tableName: _this.table.tableName,
          dataLimitsId: _this.table.id,
          dataLimitsDataList: [
            {
              tableName: _this.table.tableName,
              status: 1,
              dataId: _this.radio1,
            },
          ],
        };
        return obj;
      });
      delData = delData.map(res => {
        let obj = {
          foreignType: _this.leftIndex,
          foreignId: res.dataId,
          systemId: _this.table.systemId,
          tableName: _this.table.tableName,
          dataLimitsId: _this.table.id,
          dataLimitsDataList: [
            {
              tableName: _this.table.tableName,
              status: 0,
              dataId: _this.radio1,
              id: res.id,
            },
          ],
        };
        return obj;
      });
      let arr = [...delData, ...addData];
      console.log(arr);
      console.log(2);
      save_or_update(arr).then(async () => {
        await this.getshuju1(this.radio1);
        loadingInstance.close();
      });
    },
    /*
     *权限配置
     *快捷配置与配置切换，充值数据
     */
    choosecurrrenIndex(num) {
      this.init();
      this.currrenIndex = num;
    },
    /*重置动态数据*/
    init() {
      this.jobsId = "";
      this.jobsIndex = null;
      this.jobIds = [];
      this.roleId = "";
      this.roleIndex = null;
      this.roleIds = [];
      this.userId = "";
      this.userIndex = null;
      this.userIds = [];
      this.timer = new Date().getTime();
      this.treearrId = "";
      this.checkkey = [];
      this.tableData = [];
      this.show = [];
      this.tree1 = new Date().getTime();
      // this.$refs.functiontree.setCheckedKeys([])
      // this.$refs.tree.setCheckedKeys([])
      this.radio = "";
      this.radio1 = "";
      this.jobsinput = "";
      this.userinput = "";
      this.roleinput = "";
    },
    /*右侧导航*/
    changetight(num) {
      this.rightloading = true;
      this.functiontreeData = [];
      this.rightIndex = num;
      this.searchValue = "";
      if (num !== 5) {
        let TreeUrl = get_system_function_buttonByuser;
        if (getUserInfo().adminStatus == 1) {
          TreeUrl = functionTree;
        }
        // TreeUrl = functionTree
        TreeUrl({
          type: this.rightIndex,
        }).then(res => {
          res.data.forEach(res => {
            let arr = [];
            arr.push(res.parentId);
            arr.push(res.id);
            res.nodeId = arr.join(",");
          });
          const { data } = res;
          //所有树节点
          /*  console.log(data); */
          this.allNode = data;
          this.rightloading = false;
          if (data == []) {
            return;
          }
          if (num == 2) {
            let Array = formatTreeData(data, "id", "parentId", "children", "parent_id");
            this.functiontreeData = Array;
          } else if (num == 3) {
            let Array = formatTreeData(data, "id", "parentId", "children", "parent_id");
            this.functiontreeData = Array;
          } else {
            this.functiontreeData = formatTreeData(data, "id", "parentId", "children", "parent_id");
          }
          this.getcheckbutton(this.choiseId);
          console.log(this.functiontreeData);
        });
      } else {
        if (this.table) {
          this.gettable(this.table);
        }
        this.rightloading = false;
      }
    },
    /*左侧导航*/
    async changeleft(value) {
      this.choiseId = "";
      this.leftIndex = value;
      this.leftloading = true;
      await this.init();
      this.leftloading = false;
    },
    /*
     *权限配置--功能权限
     *获取对应得组织，岗位，用户，角色id
     */
    getforeignId() {
      let foreignId = "";
      if (this.leftIndex == "organization") {
        foreignId = this.treearrId;
      }
      if (this.leftIndex == "station") {
        foreignId = this.jobsId;
      }
      if (this.leftIndex == "user") {
        foreignId = this.userId;
      }
      if (this.leftIndex == "role") {
        foreignId = this.roleId;
      }
      return foreignId;
    },

    /*组织ID*/
    setTree(e) {
      this.treearrId = e.id;
      this.choiseId = e.id;
      if (this.rightIndex == "5") {
        this.getshuju(e.id);
      } else {
        this.getcheckbutton(e.id);
      }
    },
    /*岗位ID*/
    choosejob(item) {
      this.jobsIndex = item.id;
      this.jobsId = item.id;
      this.choiseId = item.id;
      if (this.rightIndex == "5") {
        this.getshuju(item.id);
      } else {
        this.getcheckbutton(item.id);
        console.log(2);
      }
    },

    /*用户ID*/
    chooseuser(item) {
      console.log(item);
      this.userIndex = item.id;
      this.userId = item.id;
      this.choiseId = item.id;
      if (this.rightIndex == "5") {
        this.getshuju(item.id);
      } else {
        this.getcheckbutton(item.id);
      }
    },
    /*角色ID*/
    chooserole(item) {
      this.roleIndex = item.id;
      this.roleId = item.id;
      this.choiseId = item.id;
      if (this.rightIndex == "5") {
        this.getshuju(item.id);
      } else {
        this.getcheckbutton(item.id);
      }
    },
    /**获取绑定的按钮*/
    async getcheckbutton(foreignId) {
      if (foreignId) {
        this.rightloading = true;
        let params = {
          foreignType: this.leftIndex,
          foreignId: foreignId,
          type: this.rightIndex,
        };
        await queryIds(params).then(res => {
          res.data.forEach(res => {
            let arr = [];
            arr.push(res.functionId);
            arr.push(res.buttonId);
            res.nodeId = arr.join(",");
          });
          this.checkkey = res.data;
          let key = [];
          res.data.forEach(item => {
            key.push(item.nodeId);
          });
          //console.log(key);
          this.$refs.functiontree.setCheckedKeys(key);
          this.rightloading = false;
        });
      }
    },
    //权限查看的功能查看
    async sherchButton(foreignId) {
      this.fiveLoading = true;
      if (foreignId) {
        this.rightloading = true;
        let params = {
          userId: foreignId,
        };
        let res = await get_user_auth_source(params);
        console.log(res);
        //处理权限来源source和foreignType
        let handleRes = [];
        handleRes = res.data.map(item => {
          let buttonList = item.buttonList.map(ite => {
            let source = ite.foreignType.split(",");
            return { ...ite, source };
          });
          return { ...item, buttonList, source: item.source.split(",") };
        });
        console.log("handleRes", handleRes);

        //分组生成相同的父节点
        var result = [];
        handleRes.forEach(item => {
          var { parentId, parentName, type, systemId, systemName } = item;
          if (!result[parentId]) {
            result[parentId] = {
              id: parentId,
              buttonName: parentName,
              type,
              buttonList: [],
              systemName,
              systemId,
            };
          }
          result[parentId].buttonList.push({ ...item, buttonName: item.name });
        });
        var data = Object.values(result);
        // this.sherchNode=data.filter(ite=>ite.type==this.rightIndex)
        this.sherchNode = this.loopComputation(data.filter(ite => ite.type == this.rightIndex));

        //通过systemName进一步获取归类节点
        let finalNode = [];
        this.sherchNode.forEach(item => {
          let { systemName } = item;
          if (!finalNode[systemName]) {
            finalNode[systemName] = {
              buttonName: systemName,
              buttonList: [],
            };
          }
          finalNode[systemName].buttonList.push(item);
        });
        console.log(finalNode);
        this.sherchNode = Object.values(finalNode);
        console.log("sherchNode", this.sherchNode);
        this.rightloading = false
      }
      this.fiveLoading = false;
    },
    loopComputation(arr) {
      return arr
        .map(el => {
          if (el.buttonList && el.buttonList.length > 0) {
            el.buttonList = this.loopComputation(el.buttonList);
          }
          return el;
        })
        .filter(item => item.excludeStatus !== 0)
        .filter(item2 => !item2.buttonList || (item2.buttonList && item2.buttonList.length > 0));
    },
    setDataAuthTree() {
      // if (this.rightloading) return

      this.multipleTableFun(this.$refs.rightAuthTree.getCheckedNodes());
      // let selc
      // multipleTableFun
      // let list = []
      // if (isAdd) {
      //   list.push({
      //     tableName: this.table.tableName,
      //     status: 1,
      //     dataId: item[this.treeInfo.keyId]
      //   })
      // } else {
      //   let dataItem = this.tableShow.filter(d => {
      //     return d.dataId === item[this.treeInfo.keyId]
      //   })
      //   list.push({
      //     tableName: this.table.tableName,
      //     status: 0,
      //     id: dataItem[0].id,
      //     dataId: item[this.treeInfo.keyId],
      //   })
      // }
      // let arr = [{
      //   foreignType: this.leftIndex,
      //   foreignId: this.getforeignId(),
      //   systemId: this.table.systemId,
      //   tableName: this.table.tableName,
      //   dataLimitsId: this.table.id,
      //   dataLimitsDataList: list
      // }]
      // let loadingInstance = Loading.service({ text: '数据授权中...' });
      // save_or_update(arr).then(async () => {
      //   loadingInstance.close();
      // })
    },
    /*保存功能权限*/
    getButton() {
      if (!this.getforeignId()) {
        this.$message({
          message: "警告哦，请在左侧选择要关联的数据",
          type: "warning",
        });
        this.init();
        return;
      }
      let keys = this.$refs.functiontree.getCheckedNodes();
      let data = [];
      let newkeys = [];
      newkeys = keys.filter(item => {
        return !item.children;
      });
      if (this.checkkey) {
        let loadingInstance = Loading.service({ text: "授权中..." });
        let allHasData = this.checkkey.filter(item => newkeys.some(items => item.buttonId === items.id && item.functionId == items.parentId));
        allHasData.map(res => {
          res.status = 1;
        });
        let deleteData = this.checkkey.filter(item => !allHasData.some(items => item.buttonId === items.buttonId && item.functionId == items.functionId));
        let addData = newkeys.filter(item => !allHasData.some(items => item.id === items.buttonId && item.parentId == items.functionId));
        deleteData = deleteData.map(res => {
          let obj = new Object();
          obj.type = res.type;
          obj.foreignType = res.foreignType;
          obj.foreignId = res.foreignId;
          obj.buttonId = res.buttonId;
          obj.buttonName = res.buttonName;
          obj.functionId = res.functionId;
          obj.status = 0;
          obj.id = res.id;
          return obj;
        });
        addData = addData.map(item => {
          let obj = new Object();
          obj.type = this.rightIndex;
          obj.foreignType = this.leftIndex;
          obj.foreignId = this.getforeignId();
          obj.buttonId = item.id;
          obj.buttonName = item.name;
          obj.functionId = item.parentId;
          obj.status = 1;
          return obj;
        });
        data = [...deleteData, ...addData];
        console.log(JSON.parse(JSON.stringify(addData)), "最终数据addData");
        console.log(JSON.parse(JSON.stringify(deleteData)), "最终数据deleteData");
        // console.log(JSON.parse(JSON.stringify(data)), '最终数据')
        // console.log(saveOrUpdate);
        saveOrUpdate(data).then(async () => {
          await this.getcheckbutton(this.getforeignId());
        });
        loadingInstance.close();
      }
    },
    /*
     *权限快捷配置--功能权限
     *获取功能Id
     */
    async changefunction(e) {
      let params = {
        foreignType: this.leftIndex,
        buttonId: e.id,
        type: this.rightIndex,
        functionId: e.parentId,
      };
      await queryIds1(params).then(res => {
        console.log(res.data);
        this.checkkey = res.data;
        if (this.rightIndex !== 5) {
          let key = [];
          res.data.forEach(item => {
            key.push(item.foreignId);
          });
          if (this.leftIndex == "organization") {
            this.$refs.tree.setCheckedKeys(key);
          } else if (this.leftIndex == "station") {
            this.jobIds = key;
          } else if (this.leftIndex == "user") {
            this.userIds = key;
          } else {
            this.roleIds = key;
          }
        } else {
          console.log("数据");
        }
      });
    },
    /*
     *保存对应关系
     */
    submit1() {
      let key = [];
      if (this.leftIndex == "organization") {
        key = this.$refs.tree.getCheckedKeys();
      } else if (this.leftIndex == "station") {
        key = this.jobIds;
      } else if (this.leftIndex == "user") {
        key = this.userIds;
      } else {
        key = this.roleIds;
      }
      if (this.rightIndex !== 5) {
        if (!this.foreignId) {
          this.$message({
            message: "警告哦，请先选择左侧权限",
            type: "warning",
          });
          this.init();
          return;
        }
        let loadingInstance = Loading.service({ text: "授权中..." });
        let allHasData = this.checkkey.filter(item => key.some(items => item.foreignId === items));
        let deleteData = this.checkkey.filter(item => !allHasData.some(items => item.foreignId === items.foreignId));

        let addData = key.filter(item => !allHasData.some(items => item === items.foreignId));
        allHasData = allHasData.map(res => {
          let obj = new Object();
          obj.type = res.type;
          obj.foreignType = res.foreignType;
          obj.foreignId = res.foreignId;
          obj.buttonId = res.buttonId;
          obj.buttonName = res.buttonName;
          obj.functionId = res.functionId;
          obj.status = 1;
          obj.id = res.id;
          return obj;
        });
        deleteData = deleteData.map(res => {
          let obj = new Object();
          obj.type = res.type;
          obj.foreignType = res.foreignType;
          obj.foreignId = res.foreignId;
          obj.buttonId = res.buttonId;
          obj.buttonName = res.buttonName;
          obj.functionId = res.functionId;
          obj.status = 0;
          obj.id = res.id;
          return obj;
        });
        addData = addData.map(res => {
          let obj = new Object();
          obj.type = this.rightIndex;
          obj.foreignType = this.leftIndex;
          obj.foreignId = res;
          obj.buttonId = this.foreignId.id;
          obj.buttonName = this.foreignId.name;
          obj.functionId = this.foreignId.parentId;
          obj.status = 1;
          return obj;
        });
        //...allHasData
        let data = [...deleteData, ...addData];
        saveOrUpdate(data).then(async () => {
          await this.changefunction(this.foreignId);
          loadingInstance.close();
        });
      } else {
        this.handleSelectionChange1(key);
      }
    },
  },
  computed: {
    //获取对应用户下的权限树
    showDataArr() {
      let dataArr = [];
      let data = Object.keys(this.Sherchshow);
      data.forEach(item => {
        let ite = this.newtree.filter(it => it.id == item);
        dataArr.push(
          ...ite.map(res => {
            return { ...res, source: this.Sherchshow[item].split(",") };
          })
        );
      });
      data.forEach(item => {
        let childTree = this.newtree.filter(it => it.name == "基础系统");
        let ite = childTree[0].children.filter(it => it.id == item);
        dataArr.push(
          ...ite.map(res => {
            return { ...res, source: this.Sherchshow[item].split(",") };
          })
        );
      });
      data.forEach(item => {
        let childTree = this.newtree.filter(it => it.name == "客户服务平台");
        let ite = childTree[0].children.filter(it => it.id == item);
        dataArr.push(
          ...ite.map(res => {
            return { ...res, source: this.Sherchshow[item].split(",") };
          })
        );
      });
      data.forEach(item => {
        let childTree = this.newtree.filter(it => it.name == "ICPS系统");
        let ite = childTree[0].children.filter(it => it.id == item);
        dataArr.push(
          ...ite.map(res => {
            return { ...res, source: this.Sherchshow[item].split(",") };
          })
        );
      });
      console.log("用户下的权限树", dataArr);
      return dataArr;
    },
    ...mapGetters({
      screenWidth: "getscreenWidth",
      screenHeight: "getscreenHeight",
      Collapse: "getsCollapse",
    }),
    style() {
      let num = 0;
      if (this.Collapse) {
        num = this.screenWidth - 124;
      } else {
        num = this.screenWidth - 220;
      }
      return "width:" + num + "px;";
    },
    /*     sherchShowtable() {
      let a = this.tableData.filter(data => {
        return this.tableShow.find(show => {
          return show.dataId == data.ID
        })
      })
      return a
    } */
  },
};
